import { render, staticRenderFns } from "./Escalacao.vue?vue&type=template&id=4435c010&scoped=true"
import script from "./Escalacao.vue?vue&type=script&lang=js"
export * from "./Escalacao.vue?vue&type=script&lang=js"
import style0 from "./Escalacao.vue?vue&type=style&index=0&id=4435c010&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4435c010",
  null
  
)

export default component.exports